export enum SyncStatus {
  SUCCESS = 'SUCCESS',
  PENDING = 'PENDING',
  FAIL = 'FAIL',
  PENDING_DELETE = 'PENDING_DELETE',
}

export function isSyncStatusSuccess(
  status: SyncStatus | undefined
): status is SyncStatus.SUCCESS {
  return status === SyncStatus.SUCCESS;
}

export function isSyncStatusPending(
  status: SyncStatus | undefined
): status is SyncStatus.PENDING {
  return status === SyncStatus.PENDING;
}

export function isSyncStatusFail(
  status: SyncStatus | undefined
): status is SyncStatus.FAIL {
  return status === SyncStatus.FAIL;
}

export function isSyncStatusPendingDelete(
  status: SyncStatus | undefined
): status is SyncStatus.PENDING_DELETE {
  return status === SyncStatus.PENDING_DELETE;
}

/** Whether something of the entity still waits to reach the server: an upload, a deletion or a retry. */
export function isSyncStatusAwaitingServer(status: SyncStatus | undefined): boolean {
  return isSyncStatusPending(status) || isSyncStatusPendingDelete(status) || isSyncStatusFail(status);
}
